import React from "react";
import { Helmet } from "react-helmet";
import Container from "@material-ui/core/Container";
import makeStyles from "@material-ui/core/styles/makeStyles";
import { CardsPageProvider } from "../cardsPageContext";
import Filter from "../components/Filter/Filter";
import FilterResults from "../components/FilterResults";
import { endOfTitle } from "../../../constants/constants";
import "./style.css";

const useStyles = makeStyles(() => ({
  root: {
    display: "flex",
    justifyContent: "center",
    columnGap: 24,
  },
  filterContainer: {
    position: "relative",
  },
  filterResultContainer: {
    width: 732,
  },
}));

const CardsPage = () => {
  const classes = useStyles();

  return (
    <>
      <Helmet>
        <title>Programs{endOfTitle}</title>
      </Helmet>
      <CardsPageProvider>
        <Container maxWidth="lg" className={classes.root}>
          <div className={classes.filterContainer}>
            <Filter />
          </div>
          <div className={classes.filterResultContainer}>
            <FilterResults />
          </div>
        </Container>
      </CardsPageProvider>
    </>
  );
};

export default React.memo(CardsPage);
